module.exports = __webpack_public_path__ + "img/scaled access_organigrams SCALE-01.svg";